import { Typography } from "antd";
import "./style.scss"
const { Text } = Typography
const UiCounterBatch = ({
    children,
    primary,
    ...restProp
}) => {
    return <div>
        <Text className='counter' {...restProp}>{children}</Text>
    </div>
};
export default UiCounterBatch